import axios from 'axios';
import { Message } from 'element-ui'
import router from '../router'

function MyMessage(option) {
  Message.closeAll()
  Message(option)
}
MyMessage.success = function (option) {
  Message.closeAll()
  Message.success(option)
}
MyMessage.warning = function (option) {
  Message.closeAll()
  Message.warning(option)
}
MyMessage.error = function (option) {
  Message.closeAll()
  Message.error(option)
}
MyMessage.info = function (option) {
  Message.closeAll()
  Message.info(option)
}
const server = axios.create({
  baseURL: process.env.BASE_URL
});

// 请求拦截
server.interceptors.request.use(config => {
  // 改变请求路径和请求头部
  if (config.mode) {
    // 设置请求token
    let sessionId = sessionStorage.getItem('sessionId1');
    if (sessionId) {
      config.headers.ncac_sessionid = sessionId;
    }
    config.baseURL = process.env[config.mode];
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  } else {
    // 设置请求token
    let sessionId = sessionStorage.getItem('sessionId') || sessionStorage.getItem('sessionId1');
    if (sessionId) {
      config.headers.ncac_sessionId = sessionId;
    }
    config.headers['Content-Type'] = 'application/json';
  }
  return config
}, error => {
  Promise.reject(error);
})

// 添加一个响应拦截器
server.interceptors.response.use(function (res) {

  if (res.data.errorNo) {
    // 不为0则表示发生错误抛出错误信息
    if (res.config.mode && res.data.errorNo !== 0) {
      MyMessage.error(res.data.title);
      // 201表示未登录错误，此时需要退出登录
      if (res.data.errorNo == 201) {
        console.log('登录错误', res.data.errorNo);
        router.app.$router.push('/login');
      }
    }
  }
  if (res.data.title === '没有登录' || (res.data.query && res.data.query.title === '没有登录')) {
    localStorage.clear();
    if (store.getters.socket) {
      store.getters.socket.close();
    }
    window.location.reload();
    return;
  }
  return res.data;
}, function (err) {
  MyMessage.error('系统开了个小差，请稍后再试');
  return Promise.reject(err);
});

/*
* 请求封装 用于header为：application/x-www-form-urlencoded
*/
const dataFormat = (function () {
  var rbracket = /\[\]$/;
  function buildParams(prefix, obj, traditional, add) {
    var name;
    if (Array.isArray(obj)) {
      // Serialize array item.
      obj.forEach(function (v, i) {
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v);
        } else {
          // Item is non-scalar (array or object), encode its numeric index.
          buildParams(
            prefix + "[" + (typeof v === "object" && v != null ? i : '') + "]",
            v,
            traditional,
            add
          );
        }
      });
    } else if (!traditional && Object.prototype.toString.call(obj) === "[object Object]") {
      // Serialize object item.
      for (name in obj) {
        var prefixName = prefix ? prefix + "." + name : name;
        buildParams(prefixName, obj[name], traditional, add);
      }
    } else {
      // Serialize scalar item.
      add(prefix, obj);
    }
  }
  // Serialize an array of form elements or a set of
  // key/values into a query string
  return function param(a, traditional) {
    var prefix,
      s = [],
      add = function (key, value) {
        s[s.length] = encodeURIComponent(key) + "=" +
          encodeURIComponent(value == null ? "" : value);
      };

    if (a == null) {
      return "";
    }

    // If an array was passed in, assume that it is an array of form elements.
    if (Array.isArray(a)) {
      // Serialize the form elements
      a.forEach(function (v, i) {
        add(i, v);
      });

    } else {

      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
    }

    // Return the resulting serialization
    return s.join("&");
  };
})();
export const post = function (url, data, mode) {
  return server({
    method: 'post',
    url,
    data,
    mode: mode,
    transformRequest: [function (data) {
      return dataFormat(data)
    }]
  })
};
export const get = function (url, params, mode) {
  return server({
    method: 'get',
    url,
    mode: mode,
    params
  })
};

export default server



// WEBPACK FOOTER //
// ./src/utils/request.js